<template>
  <div class="loading-screen" :class="{ 'active': isVisible }">
    <div class="loading-content">
      <!-- Animação de Caligrafia -->
      <div class="signature-container">
        <svg width="243" height="300" viewBox="0 0 243 300" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="clipmask">
              <path d="M236.33,2.23c9.43-1.67-.23,5.31-3.44,9.63-5.55,7.47-59.53,83.87-80.71,117.09-6.58,10.85-9,14.27-16,24.78-3.36,15.83-10.71,38.94-17.05,53-.95,1.44-5.03,2.11-6.77,1.63-5.2-.47,10.81-37.26,19.75-56.03,2.94-11.1,10.63-43.55,3.54-50.21-2.47-3.26-8.84-6.71-11.49-10.46-1.13-1.61-15.66,20.94-22.37,27.96-2.22,2.17-6.6.47-8.14,3.18-1.28,2.26-51.75,68.26-54.37,79.83-2.83,18.4-6.27,37.22-11.69,55.06-3.44,13.5-8.73,26.79-14.46,39.23-16.75,8.98-8.94-39.3-6.89-46.8,4.15-20.56,18.46-36.98,28.22-55.06,5.74-27.52,8.91-56.32,13.88-84.06.11-1.29-.98-.81-1.26.46-7.04,10.36-9.68,21.55-18.09,30.86-.13.13-3.86-.83-4.5-1.5-1.12-1.81,21.75-34.57,27.21-45.21,2.38-22.69,15.21-61.88,24.04-82.25,1.18-3.74,7.9-8.38,9.33-4.13,2.23,6.62-1.66,33.84-7.26,46.8-4.43,11.24-17.03,30.23-22.61,41.41-2.88,5.78-8.16,61.38-13.14,85.12-.31,1.81.98,3,2.03,1.48,7.57-10.82,15.96-21.43,23.4-32.35,10.22-14.72,5.79-7.35-2.06-11.01-5.32-2.48,14.32-39.33,22.02-53.69,8.63-9.83,24.38,6.09,16.72,18.42,4.88-4.06,20.06-19.93,20-21.6-.24-6.69-.19-9.15,2.02-12.34,3.21-4.65,9.44-2.56,9.45,2.71-.5,3.94-6.51,8.98-6.88,12.15-.6,7.43,14.34,8.53,14.46,18.58.1,8.65.41,14.83-1.28,25.19-.25,1.54,1.51,2.58,2.47,1.35C161.5,105.26,218.15,15.92,236.33,2.23ZM32.03,211.88c-.12-2.87-2.16-.72-2.83.57-12.96,18.66-21.13,39.81-20.21,62.46.51,3.82.03,7.02,2.14,10.36.74,1.24,2.44-5.74,3.29-6.52,9.39-21.37,13.33-44.14,17.61-66.87ZM99.16,97.32c2.14-7.15-6.53-6.9-9.64-2.75-7.37,11.81-12.84,26.73-17.9,39.58.69.71,2.95-1.82,3.45-2.41,8.26-10.66,17.64-22.26,24.09-34.42ZM81.27,17.14c-2.73-1.51-14.72,38.22-20.63,56.79.01,12.45,18.05-33.24,17.89-35.8.89-4.68,4.46-17.41,2.75-20.99Z" fill="white"/>
            </clipPath>
          </defs>
          <g clip-path="url(#clipmask)" stroke-linejoin="miter" stroke-miterlimit="5">
            <path 
              class="stroke-path" 
              d="M25.7,142.44c26.5-41.5,44.5-74.5,49-84s7.5-25.5,8.5-35.5c1-10,.9-13.12-3-10-6.44,5.15-12.5,24.5-16.5,39.5s-8.5,34.5-11.5,51.5-9,58.5-11,72.5-10.5,62-14,74-12.5,37-15.5,41c-3,4-6.5-4-6-18.5.5-14.5,5-34.5,13-48.5s30.5-44.5,35.5-49.5,22.5-36,30.5-45,19.5-28,18.5-34-6.5-11.5-11.5-7.5-16,25-20,38-6,16,4,10,17-18.5,23.5-23,13-14,18-19.5,12-12.5,15-17-1-8-3.5-4-5,15-1.5,18.5,14,8.5,14,13,.5,21-6,46.5-15.5,53-18.5,54.5,1-15,9-33.5,19-39.5,43.5-72.5S222.7,19.94,227.7,14.44s8-10.5,13-12" 
              stroke="black"
            />
          </g>
        </svg>
      </div>
      
      <!-- Progress Indicator (Hidden) -->
      <div class="progress-container" style="display: none;">
        <div class="progress-text">
          Carregando vídeos... {{ progress }}/{{ totalVideos }}
        </div>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: (progress / totalVideos) * 100 + '%' }"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    },
    totalVideos: {
      type: Number,
      default: 3
    }
  }
}
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease, visibility 0.5s ease;
}

.loading-screen.active {
  opacity: 1;
  visibility: visible;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
}

.signature-container {
  width: 300px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signature-container svg {
  width: 100%;
  height: auto;
  max-width: 300px;
}

.stroke-path {
  fill: none;
  stroke: black;
  stroke-width: 8;
  stroke-dasharray: 4000;
  stroke-dashoffset: 4000;
  animation: draw 3s ease-in-out forwards;
  animation-play-state: paused;
}

.loading-screen.active .stroke-path {
  animation-play-state: running;
}

.loading-screen:not(.active) .stroke-path {
  stroke-dashoffset: 4000;
  animation-play-state: paused;
}

@keyframes draw {
  0% {
    stroke-dashoffset: 4000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}



/* Progress Indicator */
.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
  max-width: 300px;
}

.progress-text {
  font-size: 14px;
  color: #666;
  font-weight: 300;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 2px;
  background-color: #e5e5e5;
  border-radius: 1px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background-color: #000;
  transition: width 0.3s ease;
}

/* Responsividade */
@media (max-width: 768px) {
  .signature-container {
    width: 200px;
  }
  
  .loading-content {
    gap: 2rem;
  }
  
  .progress-container {
    max-width: 250px;
  }
  
  .progress-text {
    font-size: 12px;
  }
}
</style> 